exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._1K1ksTpJ6QVM5ze1C3IYjm{border:1px solid;border-radius:2px;margin-top:10px;border-color:\"[theme:neutralTertiaryAlt, default:#c8c8c8]\"}._1Dsn8GfBhhExI-kyX_p-tH{font-weight:400}html[dir] ._1Dsn8GfBhhExI-kyX_p-tH{margin-top:12px}", ""]);
// Exports
exports.locals = {
	"cancelButton": "_1K1ksTpJ6QVM5ze1C3IYjm",
	"label": "_1Dsn8GfBhhExI-kyX_p-tH"
};